import React, { useState } from "react";
import { auth } from "./firebase";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import emailjs from "@emailjs/browser"; // 🌸 Import thư viện gửi mail tự động
import bannerImage from "./assets/login/banner.webp";
import brandLogo from "./assets/LOGO.png";

export default function Dangky() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState({ show: false, message: "", type: "info" });

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [fullName, setFullName] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [gender, setGender] = useState("");
  const [address, setAddress] = useState("");

  // Hàm kích hoạt hiển thị thông báo Push nhanh
  const showNotification = (message, type = "info") => {
    setToast({ show: true, message, type });
    // Tự động ẩn thông báo sau 4 giây
    setTimeout(() => {
      setToast({ show: false, message: "", type: "info" });
    }, 4000);
  };

  // ================= LUỒNG ĐĂNG KÝ BẰNG EMAIL =================
  const handleEmailRegister = async (e) => {
    e.preventDefault();
    if (!email || !password || !fullName || !birthDate || !gender || !address) {
      window.scrollTo({ top: 0, behavior: "smooth" }); // Cuộn nhẹ lên đầu để thấy thông báo
      return showNotification("Vui lòng điền đầy đủ tất cả thông tin đăng ký!", "warning");
    }
    if (password.length < 6) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return showNotification("Mật khẩu phải từ 6 ký tự trở lên!", "warning");
    }
    
    setLoading(true);
    try {
      // 1. Khởi tạo tài khoản trên Firebase
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      const userData = {
        uid: user.uid,
        email: user.email,
        fullName: fullName,
        birthDate: birthDate,
        gender: gender,
        address: address,
        registeredAt: new Date().toISOString()
      };

      // 2. Lưu trữ hồ sơ định danh vào LocalStorage
      localStorage.setItem(`user_profile_${user.email}`, JSON.stringify(userData));
      localStorage.setItem("flower_user", JSON.stringify(userData));

      // 3. TỰ ĐỘNG GỬI MAIL ĐĂNG KÝ THÀNH CÔNG QUA EMAILJS
      const templateParams = {
        customer_name: fullName,
        customer_email: email,
        reply_to: "floraison.hoa@gmail.com"
      };

      try {
        await emailjs.send(
          "service_pkqy3fq",
          "template_3s2ko1j",
          templateParams,
          "G7E9F24oqZjdEAUJx"
        );
        console.log("Email thông báo đã được gửi thành công đến khách hàng! 🌸");
      } catch (emailError) {
        console.error("Lỗi gửi EmailJS:", emailError);
      }

      showNotification("Đăng ký tài khoản Floraison thành công! Đang chuyển hướng...", "success");
      
      // Trì hoãn chuyển hướng 1.5 giây để người dùng kịp nhìn thấy thông báo thành công ngọt ngào
      setTimeout(() => {
        navigate("/");
      }, 1500);
    } catch (error) {
      console.error(error);
      window.scrollTo({ top: 0, behavior: "smooth" });
      if (error.code === "auth/email-already-in-use") {
        showNotification("Email này đã được đăng ký tài khoản khác rồi!", "error");
      } else {
        showNotification(`Lỗi hệ thống: ${error.message}`, "error");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      {/* Khối nhúng CSS nội bộ xử lý các hiệu ứng chuyển động và màu sắc */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@500;700&family=Montserrat:wght@300;400;500&family=Pinyon+Script&display=swap');
        
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes slowZoom {
          0% { transform: scale(1); }
          100% { transform: scale(1.12); }
        }
        @keyframes slideInRight {
          from { opacity: 0; transform: translateX(100%) translateY(-50%); }
          to { opacity: 1; transform: translateX(0) translateY(0); }
        }
        
        .animate-fade-in {
          animation: fadeInUp 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }
        .animate-toast {
          animation: slideInRight 0.35s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }
        
        .floral-bg {
          position: absolute;
          top: -5%; left: -5%; right: -5%; bottom: -5%;
          background-image: url('${bannerImage}');
          background-size: cover;
          background-position: center;
          animation: slowZoom 20s ease-in-out infinite alternate;
          z-index: 1;
        }
        .dark-overlay {
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          background: linear-gradient(135deg, rgba(0, 0, 0, 0.3) 0%, rgba(0,0,0,0.5) 100%);
          z-index: 2;
        }
        
        .btn-brand-action {
          background: linear-gradient(135deg, #ffcdf2 0%, #ffcdf2 100%);
          color: #000;
        }
        .btn-brand-action:hover {
          box-shadow: 0 0 20px rgba(212, 175, 55, 0.4);
          transform: translateY(-2px);
        }
        .btn-brand-action:active {
          transform: translateY(0);
        }
        .link-footer:hover {
          color: #d437aa !important;
        }

        /* Chỉnh màu cho dropdown options trên nền tối */
        select option {
          background: #1a1a1a;
          color: #ffffff;
        }

        /* Responsive Layout */
        @media (max-width: 900px) {
          .split-container { flex-direction: column !important; }
          .left-panel { flex: none !important; height: 30vh !important; border-right: none !important; border-bottom: 1px solid rgba(212, 175, 55, 0.2); }
          .right-panel { flex: 1 !important; }
        }
      `}</style>

      {/* 🛎️ COMPONENT WEB PUSH TOAST NOTIFICATION */}
      {toast.show && (
        <div style={{ ...styles.toast, ...styles[toast.type] }} className="animate-toast">
          <span style={styles.toastIcon}>
            {toast.type === "success" && "🌸"}
            {toast.type === "warning" && "⚠️"}
            {toast.type === "error" && "❌"}
            {toast.type === "info" && "ℹ️"}
          </span>
          <div style={styles.toastMessage}>{toast.message}</div>
        </div>
      )}

      {/* NỬA TRÁI: LOGO */}
      <div style={styles.leftPanel} className="left-panel">
        <img
          src={brandLogo}
          alt="Floraison Brand Logo"
          style={styles.logo}
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'block';
          }}
        />
        <h1 style={{ ...styles.fallbackLogo, display: 'none' }}>Floraison</h1>
      </div>

      {/* NỬA PHẢI: FORM ĐĂNG KÝ VỚI BANNER CHÌM */}
      <div style={styles.rightPanel} className="right-panel">
        <div className="floral-bg"></div>
        <div className="dark-overlay"></div>
        
        {/* THÊM overflowY ĐỂ FORM ĐĂNG KÝ DÀI CÓ THỂ CUỘN ĐƯỢC NẾU MÀN HÌNH NHỎ */}
        <div style={{ ...styles.card, maxHeight: "90vh", overflowY: "auto" }} className="animate-fade-in">
          <div style={styles.header}>
            <h2 style={styles.title}>Đăng ký Floraison</h2>
            <p style={styles.subtitle}>Thiết lập thông tin tài khoản để trải nghiệm dịch vụ</p>
          </div>

          <form onSubmit={handleEmailRegister} style={styles.form}>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Địa chỉ Email</label>
              <input
                type="email"
                placeholder="name@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={styles.input}
                onFocus={(e) => {
                  e.target.style.borderColor = "#d437aa";
                  e.target.style.background = "rgba(255, 255, 255, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "rgba(255, 255, 255, 0.15)";
                  e.target.style.background = "rgba(255, 255, 255, 0.05)";
                }}
              />
            </div>
            
            <div style={styles.inputGroup}>
              <label style={styles.label}>Mật khẩu</label>
              <input
                type="password"
                placeholder="Tối thiểu 6 ký tự"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={styles.input}
                onFocus={(e) => {
                  e.target.style.borderColor = "#d437aa";
                  e.target.style.background = "rgba(255, 255, 255, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "rgba(255, 255, 255, 0.15)";
                  e.target.style.background = "rgba(255, 255, 255, 0.05)";
                }}
              />
            </div>

            <hr style={styles.divider} />

            <div style={styles.inputGroup}>
              <label style={styles.label}>Họ và tên</label>
              <input
                type="text"
                placeholder="Nguyễn Văn A"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                style={styles.input}
                onFocus={(e) => {
                  e.target.style.borderColor = "#d437aa";
                  e.target.style.background = "rgba(255, 255, 255, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "rgba(255, 255, 255, 0.15)";
                  e.target.style.background = "rgba(255, 255, 255, 0.05)";
                }}
              />
            </div>

            <div style={styles.row}>
              <div style={{ ...styles.inputGroup, flex: 1 }}>
                <label style={styles.label}>Ngày sinh</label>
                <input
                  type="date"
                  value={birthDate}
                  onChange={(e) => setBirthDate(e.target.value)}
                  style={styles.input}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#d437aa";
                    e.target.style.background = "rgba(255, 255, 255, 0.1)";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = "rgba(255, 255, 255, 0.15)";
                    e.target.style.background = "rgba(255, 255, 255, 0.05)";
                  }}
                />
              </div>
              <div style={{ ...styles.inputGroup, flex: 1 }}>
                <label style={styles.label}>Giới tính</label>
                <select
                  value={gender}
                  onChange={(e) => setGender(e.target.value)}
                  style={styles.select}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#d437aa";
                    e.target.style.background = "rgba(255, 255, 255, 0.1)";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = "rgba(255, 255, 255, 0.15)";
                    e.target.style.background = "rgba(255, 255, 255, 0.05)";
                  }}
                >
                  <option value="">Chọn...</option>
                  <option value="Nam">Nam</option>
                  <option value="Nữ">Nữ</option>
                  <option value="Khác">Khác</option>
                </select>
              </div>
            </div>

            <div style={styles.inputGroup}>
              <label style={styles.label}>Địa chỉ giao hàng</label>
              <input
                type="text"
                placeholder="Số nhà, Tên đường, Quận..."
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                style={styles.input}
                onFocus={(e) => {
                  e.target.style.borderColor = "#d437aa";
                  e.target.style.background = "rgba(255, 255, 255, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "rgba(255, 255, 255, 0.15)";
                  e.target.style.background = "rgba(255, 255, 255, 0.05)";
                }}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{...styles.buttonBrand, opacity: loading ? 0.7 : 1}}
              className="btn-brand-action"
            >
              {loading ? "Đang khởi tạo tài khoản..." : "Hoàn tất đăng ký"}
            </button>
          </form>

          {/* NÚT LINK SANG TRANG ĐĂNG NHẬP */}
          <div style={styles.registerFooter}>
            <button
              type="button"
              onClick={() => navigate("/dang-nhap")}
              style={styles.btnLink}
              className="link-footer"
            >
              Đã có tài khoản? Đăng nhập ngay
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    minHeight: "100vh",
    backgroundColor: "#050505",
    fontFamily: "'Cormorant Garamond', sans-serif",
  },
  leftPanel: {
    flex: "1",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(135deg, #ffb4c3 0%, #FAF0F2 100%)",
    borderRight: "1px solid rgba(176, 47, 161, 0.15)",
    padding: "40px",
  },
  logo: {
    maxWidth: "600px",
    height: "auto",
    filter: "drop-shadow(0 0 20px rgba(212, 175, 55, 0.15))",
  },
  fallbackLogo: {
    fontFamily: "'Cinzel', serif",
    color: "#ffcaf3",
    fontSize: "3rem",
    letterSpacing: "4px",
  },
  rightPanel: {
    flex: "1",
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    padding: "20px",
  },
  card: {
    position: "relative",
    zIndex: 10,
    background: "rgba(15, 15, 15, 0.12)",
    backdropFilter: "blur(16px)",
    WebkitBackdropFilter: "blur(16px)",
    padding: "50px 40px",
    borderRadius: "20px",
    border: "1px solid rgba(68, 53, 53, 0.33)",
    boxShadow: "0 30px 60px rgba(0, 0, 0, 0.27), inset 0 1px 0 rgba(255, 255, 255, 0.13)",
    width: "100%",
    maxWidth: "460px",
    boxSizing: "border-box",
  },
  header: {
    marginBottom: "28px",
    textAlign: "center",
  },
  title: {
    fontFamily: "'Pinyon Script', serif",
    fontSize: "32px",
    fontWeight: "700",
    color: "#ffbae9",
    margin: "0 0 12px 0",
    letterSpacing: "1px",
  },
  subtitle: {
    fontSize: "13px",
    color: "#a0a0a0",
    lineHeight: "1.6",
    margin: 0,
    textTransform: "uppercase",
    letterSpacing: "2px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "18px",
  },
  inputGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  row: {
    display: "flex",
    gap: "12px",
  },
  label: {
    fontSize: "12px",
    fontWeight: "500",
    color: "#d0d0d0",
    letterSpacing: "1px",
    textTransform: "uppercase",
  },
  input: {
    padding: "12px 16px",
    border: "1px solid rgba(255, 255, 255, 0.15)",
    borderRadius: "12px",
    fontSize: "14px",
    outline: "none",
    background: "rgba(255, 255, 255, 0.05)",
    color: "#ffffff",
    boxSizing: "border-box",
    width: "100%",
    transition: "all 0.3s ease",
  },
  select: {
    padding: "12px 16px",
    border: "1px solid rgba(255, 255, 255, 0.15)",
    borderRadius: "12px",
    fontSize: "14px",
    outline: "none",
    background: "rgba(255, 255, 255, 0.05)",
    color: "#ffffff",
    boxSizing: "border-box",
    width: "100%",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  divider: {
    border: "0",
    height: "1px",
    background: "rgba(255, 255, 255, 0.1)",
    margin: "6px 0",
  },
  buttonBrand: {
    marginTop: "10px",
    padding: "15px",
    border: "none",
    borderRadius: "12px",
    fontSize: "14px",
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: "2px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    outline: "none",
  },
  registerFooter: {
    marginTop: "30px",
    textAlign: "center",
  },
  btnLink: {
    background: "none",
    border: "none",
    color: "#a0a0a0",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: "400",
    textAlign: "center",
    textDecoration: "none",
    outline: "none",
    transition: "color 0.3s ease",
    letterSpacing: "0.5px",
  },

  // 🌸 STYLES CHO TOAST PUSH NOTIFICATION (Giữ nguyên)
  toast: {
    position: "fixed",
    top: "24px",
    right: "24px",
    zIndex: 9999,
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "16px 20px",
    borderRadius: "16px",
    boxShadow: "0 12px 36px rgba(0, 0, 0, 0.3), 0 4px 12px rgba(0, 0, 0, 0.2)",
    maxWidth: "380px",
    boxSizing: "border-box",
    border: "1px solid rgba(255, 255, 255, 0.1)",
  },
  toastIcon: {
    fontSize: "18px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  toastMessage: {
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "1.4",
  },
  success: { background: "#EDF7ED", borderColor: "rgba(76, 175, 80, 0.2)", color: "#1e4620" },
  warning: { background: "#FFF4E5", borderColor: "rgba(255, 152, 0, 0.2)", color: "#663c00" },
  error: { background: "#FDEDED", borderColor: "rgba(244, 67, 54, 0.2)", color: "#5f2120" },
  info: { background: "#E5F6FD", borderColor: "rgba(31, 156, 240, 0.2)", color: "#014361" },
};